interface CurrencyConfig {
    locale: string;
    currency: string;
    threshold?: number;
    notation?: Intl.NumberFormatOptions['notation'];
}

/**
 * https://baike.baidu.com/item/ISO%204217/11018231
 */
export const currencyConfigMap = new Map<number, CurrencyConfig>([
    [1, { locale: 'zh-cn', currency: 'CNY' }], // 人民币
    [2, { locale: 'en', currency: 'USD' }], // 美元
    [12, { locale: 'th', currency: 'THB' }], // 泰铢
    [13, { locale: 'vi', currency: 'VND' }], // 越南盾
])